module.exports = __webpack_public_path__ + "static/img/page48.7aee3f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page48.jpg
// module id = UyQK
// module chunks = 0